/**
 * Convert an object to a key/value string.
 * @param {Object} the object to convert
 * @return {String} a URL encoded string 'foo=bar&boo=baz'
 */
var toSearchParam = function toSearchParam(obj) {
  return Object.keys(obj).map(function (key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key]));
  }).join('&');
};

export default toSearchParam;